import script from "./TopButton.vue?vue&type=script&setup=true&lang=js"
export * from "./TopButton.vue?vue&type=script&setup=true&lang=js"

import "./TopButton.vue?vue&type=style&index=0&id=e8322a70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8322a70"]])

export default __exports__